module.exports = __webpack_public_path__ + "brankic.4fb717080389733bf446.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/brankic.woff
// module id = 260
// module chunks = 2